import React, { useState } from 'react';

import SidebarDDLocation from '../../JobsPage/JobSidebar/SidebarDDLocation';
import SidebarDDTags from '../../JobsPage/JobSidebar/SidebarDDTags';
import SidebarDDJobtypes from '../../JobsPage/JobSidebar/SidebarDDJobtypes';
import SidebarDDExperience from '../../JobsPage/JobSidebar/SidebarDDExperience';

const CLSidebar = () => {
    const [recommendedChecked, setRecommendedChecked] = useState(false);

    const experience = [
        { value: '', label: 'New Graduate' },
        { value: 'entrylevel', label: 'Entry-Level' },
        { value: 'associate', label: 'Associate' },
        { value: 'midsenior', label: "Mid-Senior Level" },
        { value: 'director', label: "Director" },
        { value: 'executive', label: "Executive" }
    ]

    const headcount = [
        { value: 'startup', label: '1 - 10' },
        { value: 'smallteam', label: '11 - 50' },
        { value: 'growing', label: '51 - 200' },
        { value: 'midsize', label: '201 - 500' },
        { value: 'enterprise', label: '500+' },
    ];

    const handleRecommendedClick = () => {
        console.log("checked");
    }

    const handleResetRecommendations = () => {
        console.log("unchecked")
    }

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setRecommendedChecked(checked);
        if (checked) {
            handleRecommendedClick();
        } else {
            handleResetRecommendations();
        }
    };

    return (
        <div className="hidden p-5 sm:flex sm:flex-col overflow-y-auto bg-[#07A28714] border-r w-full h-[calc(100vh-4rem)]">
            {/* <div className="flex items-center justify-between gap-2 mb-9">
                <div className='flex items-center gap-2'>
                    <h2 className="text-2xl font-dmsans font-bold text-[#5A6474]">Job Searcher</h2>
                    <SearchIcon style={{ transform: 'scaleX(-1)' }} sx={{ color: '#5A6474' }} />
                </div>

                <button className='bg-[#4E73F8] hover:bg-blue-600 text-white text-sm font-dmsans font-normal px-4 py-1 rounded-md'>
                    Apply
                </button>
            </div> */}

            <div className='flex flex-col w-full gap-7'>
                <label className="flex items-center gap-2 text-[#5A6474] text-sm font-dmsans font-medium cursor-pointer">
                    <input
                        type="checkbox"
                        checked={recommendedChecked}
                        onChange={handleCheckboxChange}
                        className="w-4 h-4"
                    />
                    Recommended for me
                </label>

                <div className="bg-[#FFFFFF] w-full shadow-md rounded-lg text-xl">
                    <SidebarDDLocation title="Location" placeholder={"location"} />
                </div>

                <div className="bg-[#FFFFFF] w-full shadow-md rounded-lg text-xl">
                    <SidebarDDExperience
                        title="Experience Label"
                        options={experience}
                    />
                </div>

                <div className="bg-[#FFFFFF] w-full shadow-md rounded-lg text-xl">
                    <SidebarDDTags />
                </div>

                <div className="bg-[#FFFFFF] w-full shadow-md rounded-lg text-xl">
                    <SidebarDDJobtypes title="Headcount" options={headcount} />
                </div>
            </div>
        </div>
    )
}

export default CLSidebar
